import(/* webpackMode: "eager" */ "/app/apps/platform-web/app/career-launch/error.tsx");
